var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [
              _c(
                "text-header",
                {
                  staticClass: "atmo-hash-jump-point",
                  attrs: { id: "atmo-supplier-info" },
                },
                [_vm._v("Информация о поставщике (исполнителе)")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("text-row-link", {
        attrs: {
          compact: "",
          "label-cols-lg": 4,
          "label-cols-sm": 4,
          label: "Наименование",
          "router-link": {
            name: "OrganizationShow",
            params: { id: _vm.proposal.supplier.id },
          },
        },
        model: {
          value: _vm.proposal.supplier.full_name,
          callback: function ($$v) {
            _vm.$set(_vm.proposal.supplier, "full_name", $$v)
          },
          expression: "proposal.supplier.full_name",
        },
      }),
      _c("text-row", {
        attrs: {
          compact: "",
          "label-cols-lg": 4,
          "label-cols-sm": 4,
          label: "ИНН",
        },
        model: {
          value: _vm.proposal.supplier.inn,
          callback: function ($$v) {
            _vm.$set(_vm.proposal.supplier, "inn", $$v)
          },
          expression: "proposal.supplier.inn",
        },
      }),
      _c("text-row", {
        attrs: {
          compact: "",
          "label-cols-lg": 4,
          "label-cols-sm": 4,
          label: "КПП",
        },
        model: {
          value: _vm.proposal.supplier.kpp,
          callback: function ($$v) {
            _vm.$set(_vm.proposal.supplier, "kpp", $$v)
          },
          expression: "proposal.supplier.kpp",
        },
      }),
      _c("text-row", {
        attrs: {
          compact: "",
          "label-cols-lg": 4,
          "label-cols-sm": 4,
          label: "ОГРН",
        },
        model: {
          value: _vm.proposal.supplier.ogrn,
          callback: function ($$v) {
            _vm.$set(_vm.proposal.supplier, "ogrn", $$v)
          },
          expression: "proposal.supplier.ogrn",
        },
      }),
      _c("text-row", {
        attrs: {
          compact: "",
          "label-cols-lg": 4,
          "label-cols-sm": 4,
          label: "Юридический адрес",
        },
        model: {
          value: _vm.proposal.supplier.legal_address,
          callback: function ($$v) {
            _vm.$set(_vm.proposal.supplier, "legal_address", $$v)
          },
          expression: "proposal.supplier.legal_address",
        },
      }),
      _vm.showDocuments
        ? _c("text-row-single-document", {
            attrs: {
              "label-cols-lg": 4,
              "label-cols-sm": 4,
              compact: "",
              label: "Карточка предприятия",
            },
            model: {
              value: _vm.proposal.organization_card,
              callback: function ($$v) {
                _vm.$set(_vm.proposal, "organization_card", $$v)
              },
              expression: "proposal.organization_card",
            },
          })
        : _vm._e(),
      _c(
        "text-row-raw",
        {
          attrs: {
            label: "Подтверждение требований к поставщикам",
            "label-cols-lg": 4,
            "label-cols-sm": 4,
            compact: "",
          },
        },
        [
          _c("ul", { staticClass: "fs-14 grey-color my-auto col-form-label" }, [
            _vm.proposal.supplier_requirements_confirmed.supplier_reqs_a
              ? _c("li", [
                  _c("i", { staticClass: "atmo-icon-checkbox" }),
                  _vm._v(
                    " Поставщик подтвердил, что соответствует требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ. "
                  ),
                  _c(
                    "ul",
                    [
                      _c("li", [
                        _vm._v(
                          "Документы, подтверждающие соответствие требованиям:"
                        ),
                      ]),
                      _vm._l(
                        _vm.proposal.supplier_requirements_confirmed
                          .supplier_required_documents,
                        function (document, index) {
                          return _c("li", { key: index }, [
                            _c("ul", { staticClass: "ml-3" }, [
                              _c("li", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      `${index + 1}. ${document.name} - `
                                    ) +
                                    " "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "fs-14 atmo-button-link",
                                    attrs: {
                                      href: _vm.$getAttachmentDownloadLink(
                                        document.storedDocument.id
                                      ),
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v(_vm._s(document.storedDocument.name))]
                                ),
                              ]),
                            ]),
                          ])
                        }
                      ),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm.proposal.supplier_requirements_confirmed.supplier_reqs_b
              ? _c("li", [
                  _c("i", { staticClass: "atmo-icon-checkbox" }),
                  _vm._v(
                    " Поставщик подтвердил, что соответствует требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ. "
                  ),
                ])
              : _vm._e(),
            _vm.proposal.supplier_requirements_confirmed.supplier_reqs_c
              ? _c("li", [
                  _c("i", { staticClass: "atmo-icon-checkbox" }),
                  _vm._v(
                    " Поставщик подтвердил, что соответствует требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ. "
                  ),
                ])
              : _vm._e(),
            _vm.proposal.supplier_requirements_confirmed.supplier_reqs_sonko
              ? _c("li", [
                  _c("i", { staticClass: "atmo-icon-checkbox" }),
                  _vm._v(" Поставщик подтвердил, что является "),
                  _c(
                    "abbr",
                    {
                      attrs: {
                        title:
                          "Социально ориентированная некоммерческая организация",
                      },
                    },
                    [_vm._v("СОНКО")]
                  ),
                  _vm._v("."),
                ])
              : _vm._e(),
            !!_vm.proposal.supplier_requirements_confirmed
              .additional_requirements &&
            _vm.proposal.supplier_requirements_confirmed.additional_requirements
              .length > 0
              ? _c("li", [
                  _c("i", { staticClass: "atmo-icon-checkbox" }),
                  _vm._v(
                    " Поставщик подтвердил соответствие дополнительным требованиям приложив следующие документы: "
                  ),
                  _c(
                    "ul",
                    _vm._l(
                      _vm.proposal.supplier_requirements_confirmed
                        .additional_requirements,
                      function (requirement, index) {
                        return _c("li", { key: index }, [
                          _c("ul", { staticClass: "ml-3" }, [
                            _c("li", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    `${index + 1}. ${
                                      requirement.description
                                    } (Причина: ${requirement.reason}) - `
                                  ) +
                                  " "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "fs-14 atmo-button-link",
                                  attrs: {
                                    href: _vm.$getAttachmentDownloadLink(
                                      requirement.attachment.id
                                    ),
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(requirement.attachment.name))]
                              ),
                            ]),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _vm.showDocuments && _vm.proposal.commercial_proposal
        ? _c("text-row-single-document", {
            attrs: {
              "label-cols-lg": 4,
              "label-cols-sm": 4,
              compact: "",
              label: "Коммерческое предложение",
            },
            model: {
              value: _vm.proposal.commercial_proposal,
              callback: function ($$v) {
                _vm.$set(_vm.proposal, "commercial_proposal", $$v)
              },
              expression: "proposal.commercial_proposal",
            },
          })
        : _vm._e(),
      _vm.showDocuments && _vm.proposal.documents.length > 0
        ? _c("text-row-documents", {
            attrs: {
              compact: "",
              label: "Дополнительные документы",
              "label-cols-lg": 4,
              "label-cols-sm": 4,
            },
            model: {
              value: _vm.proposal.documents,
              callback: function ($$v) {
                _vm.$set(_vm.proposal, "documents", $$v)
              },
              expression: "proposal.documents",
            },
          })
        : _vm._e(),
      _vm.proposal.show_deliverables
        ? _c("text-row-proposal-specification-table", {
            attrs: { "without-vat": _vm.proposal.without_vat },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "fs-14 fw-600",
                          staticStyle: { "padding-left": "5px" },
                        },
                        [_vm._v("Спецификация принятого предложения:")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2932562217
            ),
            model: {
              value: _vm.proposal.deliverables,
              callback: function ($$v) {
                _vm.$set(_vm.proposal, "deliverables", $$v)
              },
              expression: "proposal.deliverables",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }